import React, { useEffect } from 'react';
import IncidentsSearch from './IncidentsSearch';
import IncidentsList from './IncidentsList';
import { selectOpenedModalType } from '../../../redux/selectors/modal';
import { ModalSliceType } from '../../../redux/slices/modal';
import { useAppSelector } from '../../../redux/hooks';
import { useAnalytics } from '../../../utils/analytics/useAnalytics';
import { pageViewed } from '../../../utils/analytics/events/page/events';
import CreateIncidentModal from './CreateIncidentModal';

export default () => {
  const { track } = useAnalytics();
  useEffect(() => {
    track(
      pageViewed({
        category: 'incidents',
        name: 'manage incident',
        id: null,
      }),
    );
  }, [track]);

  const isCreateModalOpen = useAppSelector((state) =>
    selectOpenedModalType(state, ModalSliceType.IncidentCreate, ''),
  );

  return (
    <>
      <IncidentsSearch />
      <IncidentsList />
      {isCreateModalOpen && <CreateIncidentModal />}
    </>
  );
};
